<template>
  <div class="page-content">
<!--    <el-button type="primary" @click="addInfo">新增</el-button>-->
<!--    <el-button type="primary" @click="editBatch">批量编辑</el-button>-->
    <page-template
      ref="cdGoodsTemplate"
      :tableOptions="tableOptions"
      :searchOptions="searchOptions"
      :toolConfig="toolConfig"
    ></page-template>
    <el-dialog title='批量修改商品' :visible.sync="batchShow" @close="closeDialog" width="800px" center :close-on-click-modal="false">
      <el-form ref="form" :model="form" :rules="rules" class="steps-form" :show-message="false" label-width="80px">
        <el-col :span="24">
          <el-form-item label='是否上架' prop="isOnLine">
            <el-switch
              v-model="form.allOnLine"
              :active-value="1"
              :inactive-value="0"
              active-text="开"
              inactive-text="关">
            </el-switch>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label='是否售罄' prop="isSoldOut">
            <el-switch
              v-model="form.allSoldOut"
              :active-value="1"
              :inactive-value="0"
              active-text="开"
              inactive-text="关">
            </el-switch>
          </el-form-item>
        </el-col>
<!--        <el-col :span="24">-->
<!--          <el-form-item label='商品售价' prop="price">-->
<!--            <el-input v-model.trim="form.price" placeholder='请输入'></el-input>-->
<!--          </el-form-item>-->
<!--        </el-col>-->
        <div class="dialog-footer">
          <el-button type="primary" @click="save">保存</el-button>
        </div>
      </el-form>
    </el-dialog>
    <el-dialog title="商品管理" :visible.sync="dialogShow" width="1200px" height="800" @close="closeDialog" :close-on-click-modal="false">
      <takeout-goods v-if="dialogShow" ref="goodsSync" :isSelect="syncTableOptions.isSelect" :tableOptions="syncTableOptions" @close="closeSync"></takeout-goods>
    </el-dialog>
  </div>
</template>

<script>
  import fileTemplate from "@/components/controls/fileTemplate";
  import pageTemplate from '@/components/template/pageTemplate';
  import takeoutGoods from "@/components/business/takeoutGoods";
  import api from '@/config/api';
  import userPower from "@/mixin/userPower";

  export default {
  mixins: [userPower],
  components: {
    pageTemplate,fileTemplate,takeoutGoods
  },
  data() {
    return {
      statusList:[
        {name:'全部',id:null},
        {name:'已同步',id:1},
        {name:'未同步',id:0},
      ],
      isDisabled:false,
      form:{
        price:'',//售价
        allSoldOut:1,//是否售罄
        allOnLine:1,//是否上架
        type:0,
        goodsList:[],
      },
      rules:{
        // price:[{required:true,trigger:'change'}],
      },
      batchShow:false,
      dialogShow: false,
      // 搜索条件
      searchOptions: {
        labelWidth:'80',
        hiddenReset:true,
        simple: [
          {
            label: '选择门店',
            prop: 'subStoreId',
            labelKey:'storeName',
            uniqueKey:'storeId',
            type: 'select',
            placeholder: "请选择门店",
            clearable:true,
            data:[],
            // url: api.takeout.takeoutStore,
            change:this.selectStore,
          },
          {
            label: '条码',
            prop: 'barCode',
            type: 'input',
            placeholder: "请输入条码",
          },
          {label: '商品名称', prop: 'name', type: 'input', isFuzzy: true, placeholder: "请输入名称"}
        ]
      },
      // 更多功能
      toolConfig: [
        {
          label: '批量编辑',
          type: this.$utils.buttonType.searchAfter,
          code: 'batchModifying',
          callback: this.editBatch,
        },
        {
          label: '编辑',
          type: this.$utils.buttonType.tableOperate,
          code: 'update',
          callback: this.editInfo,
        },
        {
          label: '新增',
          type: this.$utils.buttonType.tableOperate,
          code: 'insert',
          callback: this.addInfo,
        },
        {
          label: '删除',
          type: this.$utils.buttonType.tableOperate,
          code: 'delete',
          filter:()=>{
            return false
          }
        },
      ],
      // 表格信息配置
      tableOptions: {
        showSelect: true,
        indexShow: true,//是否显示索引
        indexMethod: (index) => {//自定义列索引
          return index + 1;
        },
        pageList:[10, 15, 20, 30, 40,50],//每页条数
        columns: [
          {label: '条码', prop: 'barCode', align: 'center'},
          {label: '品名', prop: 'name', align: 'center'},
          {label: '售价', prop: 'retailPrice', align: 'center'},
          {
            label: '是否上架',
            prop: 'onLine',
            type: 'switch',
            activeValue: true,//开启
            inactiveValue: false,//关闭
            align: 'center',
            change:this.onLineChange,
          },
          {
            label: '是否售罄',
            prop: 'soldOut',
            type: 'switch',
            activeValue: true,//开启
            inactiveValue: false,//关闭
            align: 'center',
            change:this.soldOutChange,
          },
          // {label: '图片', prop: 'logo', align: 'center'},
          // {
          //   label: '同步状态',
          //   prop: 'cdStoreSync',
          //   width: '80',
          //   align: 'center',
          //   enumData: this.$utils.getCacheStatus('cdStore.status')
          // },
          {label: '最后操作人', prop: 'lastModifyDesc', width: '120', align: 'center'},
          {
            label: '操作时间',
            prop: 'lastModifyDttm',
            width: '120',
            align: 'center',
          },
        ],
        param:{},
        // url: api.takeout.cdGoods
      },
      //同步商品
      syncTableOptions: {
        isSelect:true,
        indexShow: true,//是否显示索引
        indexMethod: (index) => {//自定义列索引
          return index + 1;
        },
        columns: [
          {
            label: '商品条码',
            prop: 'barCode',
            width: '210',
            align: 'center'
          },
          {
            label: '商品名称',
            prop: 'name',
            type: 'input',
            width: '150',
            align: 'center'
          },
          {
            label: '规格',
            prop: 'specs',
            width: '100',
            align: 'center'
          },
          {
            label: '单位',
            prop: 'unitName',
            width: '80',
            align: 'center'
          },
          {
            label: '售价',
            prop: 'retailPrice',
            width: '150',
            align: 'center',
            type: 'inputNumber',
            precision: 2
          },
        ],
        url: api.takeout.asGoodsSync
      },
      storeList:[],
      dialogTitle:'',
      isEdit:false,
      searchForm:{
        storeId:'',
        relateType:null
      }
    };
  },
  created() {
    this.getStoreList()
  },
  mounted() {

  },
  methods: {
    // 获取门店
    getStoreList(){
      let subStoreId= this.searchOptions.simple.filter(item => item.prop === 'subStoreId')[0]
      let user = this.$utils.getSysUser();
        this.$axios.fetchPost(api.takeout.takeoutStore+'/list', {status:20}).then(res => {
          if (res.code == 200) {
            subStoreId.data = res.data
            if(res.data.length>0){
              // if(user.storeId){
              //   this.$refs['cdGoodsTemplate'].$refs.searchFormTemp.formModel.subStoreId = user.storeId;
              // }else{
                res.data.forEach(v=>{
                  if(v.relateType === 10){
                    this.$refs['cdGoodsTemplate'].$refs.searchFormTemp.formModel.subStoreId = v.storeId;
                  }else{
                    if(user.storeId == v.subStoreId){
                      this.$refs['cdGoodsTemplate'].$refs.searchFormTemp.formModel.subStoreId = v.storeId;
                    }
                  }
                })
              // }
              this.tableOptions.param.subStoreId = this.$refs['cdGoodsTemplate'].$refs.searchFormTemp.formModel.subStoreId
              this.searchForm.subStoreId = this.$refs['cdGoodsTemplate'].$refs.searchFormTemp.formModel.subStoreId
              this.tableOptions.url = api.takeout.cdGoods
              this.$refs['cdGoodsTemplate'].searchSubmit(this.tableOptions.param)//查询
            }
          } else {
            this.$message({type: 'error', message: res.msg});
          }
        }).catch(err => {console.log(err)})
    },
    // 选择门店
    selectStore(val){
        this.searchOptions.simple.filter(item => item.prop === 'subStoreId')[0].data.forEach(v=>{
          if(val.subStoreId === v.storeId){
            this.searchForm.subStoreId = v.storeId
            this.searchForm.relateType = v.relateType
          }
        })
    },
    // 是否上架
    onLineChange(row){
      let arr = []
      arr.push(row)
      this.changeStatus(2,arr)
    },
    // 是否售罄
    soldOutChange(row){
      let arr = []
      arr.push(row)
      this.changeStatus(1,arr)
    },
    changeStatus(type,arr){
      let loading = this.$loading({
        lock: true,
        text: '修改中，请稍候...',
        background: 'rgba(225, 225, 225, 0.8)',
      });
      this.$axios.fetchPost(api.takeout.cdGoodsStatus, {type:type,goodsList:arr,subStoreId:this.searchForm.subStoreId}).then(res => {
        if (res.code == 200) {
          setTimeout(()=>{
            this.$notify({
              type: "success",
              title: '修改操作',
              message: '成功',
              showClose: false,
            });
            // this.$message({type: 'success', message: '修改成功'});
          },3000)
        } else {
          this.$message({type: 'error', message: res.errorMsg});
        }
      }).catch(err => {
        this.$notify({
          type: "error",
          title: '修改操作',
          message: '失败',
          showClose: false,
        });
        // this.$message({type: 'error', message: '操作失败!'});
      }).finally(() => {
          setTimeout(()=>{
            this.$refs.cdGoodsTemplate.operationSuccess()
            loading.close()
          },3000)
      })
    },

    //新增门店
    addInfo() {
      this.dialogTitle = '新增'
      this.dialogShow = true
    },
    // 编辑
    editInfo(row){
      this.dialogTitle = '编辑'
      this.dialogShow = true
    },
    // 批量编辑
    editBatch(){
      let tableRows = this.$refs.cdGoodsTemplate.getTableSelectRow();//获取批量选择的数据
      if (tableRows.length == 0) {
        this.$message({message: '请至少选择一条数据进行操作', type: 'warning'});
      } else {
        this.batchShow = true
      }
    },
    // 批量修改保存
    save(){
     if(!this.form.allSoldOut && this.form.allOnLine){
       this.form.type = 1//售罄
     }else if(this.form.allSoldOut && !this.form.allOnLine){
       this.form.type = 2//上架
     }else{
       this.form.type = 0
     }
      this.form.goodsList = this.$refs.cdGoodsTemplate.getTableSelectRow()
      this.form.subStoreId = this.searchForm.subStoreId
      this.$loading({text:'提交中，请稍后。。。'})
      this.$axios.fetchPost(api.takeout.cdGoodsStatus, this.form).then(res => {
        if (res.code == 200) {
          setTimeout(()=>{
            this.$refs.cdGoodsTemplate.operationSuccess()
            this.$notify({
              type: "success",
              title: '修改操作',
              message: '成功',
              showClose: false,
            });
            // this.$message({type: 'success', message: '修改成功'});
            this.closeDialog()
            this.$loading({}).close()
          },3000)
        } else {
          this.$loading({}).close()
          this.$message({type: 'error', message: res.msg});
        }
      }).catch(err => {
        this.$notify({
          type: "error",
          title: '修改操作',
          message: '失败',
          showClose: false,
        });
        // this.$message({type: 'error', message: '操作失败!'});
        this.$loading({}).close()
      })
    },
    // 同步弹框关闭
    closeSync(){
      this.dialogShow = false
      this.$refs.cdGoodsTemplate.operationSuccess()
    },
    // 关闭弹框
    closeDialog(){
      this.dialogShow = false
      this.batchShow = false
      this.form={
        price:'',//售价
        allSoldOut:1,//是否售罄
        allOnLine:1,//是否上架
        type:0,
        goodsList:[],
      }
    },
  }
};
</script>

<style scoped>
.steps-form >>> .el-form-item{
  min-height: 35px;
}
/*时间选择器加宽*/
.steps-form >>> .el-date-editor.el-input, .el-date-editor.el-input__inner{
  width: 300px;
  padding:0 3px;
}
/*至 加宽*/
.steps-form >>> .el-date-editor .el-range-separator{
  padding:0;
  line-height: unset;
}
.steps-form >>> .el-date-editor .el-range__icon{
  line-height: 30px;
}
/*详细地址 备注*/
.inputStyle{
  width: 70%;
}
.steps-form >>> .el-checkbox-group{
  height:30px;
}
#container {
  width:80%;
  height: 300px;
  margin:10px 0;
}
>>> .el-dialog {
  position: absolute;
  top: 50%;
  left: 50%;
  margin: 0 !important;
  transform: translate(-50%, -50%);
  max-height: calc(100% - 10px);
  /*max-width: calc(100% - 30px);*/
  display: flex;
  flex-direction: column;
}
>>> .el-dialog__body {
  overflow: auto;
  padding:0 50px;
}
>>> .el-dialog__header{
  margin-bottom: 10px !important;
}
.dialog-footer button{
  margin: 10px 0;
}

</style>



// WEBPACK FOOTER //
// src/page/takeOut/goods.vue